var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CheckoutStepLayout',{attrs:{"title":_vm.$lang('Elige la forma de pago')}},_vm._l((_vm.checkout.stepViewData.paymentMethods),function(method,i){return _c('div',{key:i},[(_vm.compExists(method))?_c(_vm.compName(method),{tag:"component",attrs:{"data":method.checkoutData},on:{"optionSelected":function($event){return _vm.checkout.stepSubmit({
					methodKey: method.methodKey,
					input: $event,
				})}}}):_vm._e()],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }